var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "contBox"
  }, [_vm._l(_vm.infoList2, function (item, index) {
    return _c("div", {
      key: index
    }, _vm._l(item.sharedData, function (item2, index2) {
      return _c("div", {
        key: index2
      }, [item.method != "ORSIGN" ? _c("div", _vm._l(item2.editableArea, function (item3, index3) {
        return _c("div", {
          key: index3
        }, [item3.controlTitle ? _c("top-title", [_c("span", {
          attrs: {
            slot: "title"
          },
          slot: "title"
        }, [_vm._v(_vm._s(_vm.$t(item3.controlTitle)))])]) : _vm._e(), _c("div", {
          staticClass: "listBox"
        }, [item3.controlType != "table" ? _c("div", [_c("a-card", {
          staticClass: "itemBox",
          attrs: {
            bordered: true,
            hoverable: "",
            title: _vm.$t("操作人") + ":" + item2.userName
          }
        }, _vm._l(item3.control, function (item4, index4) {
          return _c("div", {
            key: index4
          }, [item4.partsType != "picture" && item4.partsType != "enclosure" ? _c("div", {
            staticClass: "infoItem",
            staticStyle: {
              "margin-bottom": "10px"
            }
          }, [_c("div", {
            staticClass: "left"
          }, [_vm._v(_vm._s(_vm.$t(item4.controlName)) + ":")]), _c("div", {
            staticClass: "right"
          }, [_vm._v(_vm._s(item4.value || "-"))])]) : _c("div", {
            staticClass: "infoItem",
            staticStyle: {
              "margin-bottom": "10px"
            }
          }, [_c("div", {
            staticClass: "left"
          }, [_vm._v(_vm._s(_vm.$t(item4.controlName)) + ":")]), _c("div", {
            staticClass: "right"
          }, [item4.value.length != 0 ? _c("picture-item", {
            attrs: {
              pictureList: item4.value,
              showRemoveIcon: false,
              partsType: item4.partsType
            }
          }) : _c("span", [_vm._v("-")])], 1)])]);
        }), 0)], 1) : _c("div", {
          staticClass: "marginB20"
        }, [_c("a-table", {
          staticClass: "marginT20",
          attrs: {
            bordered: "",
            columns: item3.control,
            rowKey: "id",
            "data-source": item3.value,
            pagination: false
          },
          scopedSlots: _vm._u([{
            key: "index",
            fn: function (text, record, index) {
              return [_vm._v(" " + _vm._s(index + 1) + " ")];
            }
          }, {
            key: "photo",
            fn: function (text, record) {
              return _vm._l(record.photo, function (item4, index4) {
                return _c("img", {
                  key: index4,
                  staticStyle: {
                    width: "50px",
                    height: "50px",
                    "margin-right": "5px"
                  },
                  attrs: {
                    src: item
                  },
                  on: {
                    click: function ($event) {
                      ;
                      _vm.previewImage = item4, _vm.previewVisible = true;
                    }
                  }
                });
              });
            }
          }], null, true)
        })], 1)])], 1);
      }), 0) : _c("div", [item2.controlTitle ? _c("top-title", [_c("span", {
        attrs: {
          slot: "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(_vm.$t(item2.controlTitle)))])]) : _vm._e(), item2.controlType != "table" ? _c("div", {
        staticClass: "listBox"
      }, [_c("a-card", {
        staticClass: "itemBox",
        attrs: {
          bordered: true,
          hoverable: ""
        }
      }, _vm._l(item2.control, function (item4, index4) {
        return _c("div", {
          key: index4
        }, [item4.partsType != "picture" && item4.partsType != "enclosure" ? _c("div", {
          staticClass: "infoItem",
          staticStyle: {
            "margin-bottom": "10px"
          }
        }, [_c("div", {
          staticClass: "left"
        }, [_vm._v(_vm._s(_vm.$t(item4.controlName)) + ":")]), _c("div", {
          staticClass: "right"
        }, [_vm._v(_vm._s(item4.value || "-"))])]) : _c("div", {
          staticClass: "infoItem",
          staticStyle: {
            "margin-bottom": "10px"
          }
        }, [_c("div", {
          staticClass: "left"
        }, [_vm._v(_vm._s(_vm.$t(item4.controlName)) + ":")]), _c("div", {
          staticClass: "right"
        }, [item4.value.length != 0 ? _c("picture-item", {
          attrs: {
            pictureList: item4.value,
            showRemoveIcon: false,
            partsType: item4.partsType
          }
        }) : _c("span", [_vm._v("-")])], 1)])]);
      }), 0)], 1) : _c("div", {
        staticClass: "marginB20"
      }, [_c("a-table", {
        staticClass: "marginT20",
        attrs: {
          bordered: "",
          columns: item2.control,
          rowKey: "id",
          "data-source": item2.value,
          pagination: false
        },
        scopedSlots: _vm._u([{
          key: "index",
          fn: function (text, record, index) {
            return [_vm._v(" " + _vm._s(index + 1) + " ")];
          }
        }, {
          key: "photo",
          fn: function (text, record) {
            return _vm._l(record.photo, function (item5, index5) {
              return _c("img", {
                key: index5,
                staticStyle: {
                  width: "50px",
                  height: "50px",
                  "margin-right": "5px"
                },
                attrs: {
                  src: item5
                },
                on: {
                  click: function ($event) {
                    ;
                    _vm.previewImage = item5, _vm.previewVisible = true;
                  }
                }
              });
            });
          }
        }], null, true)
      })], 1)], 1)]);
    }), 0);
  }), _c("a-modal", {
    attrs: {
      visible: _vm.previewVisible,
      footer: null
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  }, [_c("img", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      src: _vm.previewImage
    }
  })])], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };